import React from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";

const FunFact = (props) => {
  const { t } = useTranslation("home");
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <section className={`funfact-section  ${props.fnClass}`}>
      <div className="funfact-wrap section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10 col-12">
              <div className="funfact-content">
                <div className="top-content">
                  <h2 className="title">{t("funfact.title")}</h2>
                  <h3 className="sudtitle">{t("funfact.subtitle")}</h3>
                  <p className="text">{t("funfact.text")}</p>
                </div>
                <div className="funfact">
                  <div className="item">
                    <h2>
                      <span>
                        <CountUp end={300} enableScrollSpy />
                      </span>
                      +
                    </h2>
                    <h4>{t("funfact.stats.enrolled")}</h4>
                  </div>
                  <div className="item">
                    <h2>
                      <span>
                        <CountUp end={10} enableScrollSpy />
                      </span>
                      +
                    </h2>
                    <h4>{t("funfact.stats.staff")}</h4>
                  </div>
                  <div className="item">
                    <h2>
                      <span>
                        <CountUp end={1} enableScrollSpy />
                      </span>
                      
                    </h2>
                    <h4>{t("funfact.stats.institution")}</h4>
                  </div>
                  {/* <div className="item">
                    <h2>
                      <span>
                        <CountUp end={80} enableScrollSpy />
                      </span>
                      +
                    </h2>
                    <h4>Emam</h4>
                  </div> */}
                </div>
                <LocalizedLink
                  onClick={ClickHandler}
                  to="/contact"
                  className="theme-btn"
                >
                  {t("funfact.cta")}
                </LocalizedLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;
